export default __webpack_public_path__ + "static/media/calories.18a99c36.png";